export var isCommunity = function () { return window.location.pathname.includes('/community'); };
